import Sortable from "sortablejs";

export const AccordionHook = {
  mounted() {
    renderSortableList(this.el, this);
  },
};

function renderSortableList(el, list) {
  new Sortable(el, {
    animation: 150,
    ghostClass: "blue-background-class",
    handle: ".accordion-item-header",
    onUpdate: (e) => {
      list.pushEvent("sort_list", {
        old_index: e.oldDraggableIndex,
        new_index: e.newDraggableIndex,
      });
    },
  });
}
